import React from 'react';
import { TFunction } from 'i18next';
import { WidgetsKindEnum } from 'graphql-common';
import { FieldItem, Values } from '@lib/interfaces/form';
import Select from '@lib/components/Select/Select';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageIconColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import WidgetFieldNames from '@lib/enums/fieldNames/widgetFieldNames';
import getTimeZones from '@lib/utils/getTimeZones';
import {
  isWidgetSelected,
  getConditionalSelectValidation,
} from './validationHelpers';

// Cache timezone options at module level to avoid recalculation
const TIMEZONE_OPTIONS = getTimeZones();

/**
 * Returns fields for Clock widget
 */
export default function getClockFields(t: TFunction): FieldItem[] {
  return [
    {
      name: WidgetFieldNames.ClockInfo,
      customRender: () => (
        <SupportiveMessage
          text={t('home.widget-clock-info')}
          leftIcon="info"
          color={SupportiveMessageColor.Gray}
          iconColor={SupportiveMessageIconColor.Inner}
          type={SupportiveMessageType.Transparent}
          hasBottomSpace={false}
        />
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.Clock),
    },
    {
      name: WidgetFieldNames.Timezone,
      label: t('timezone'),
      element: Select,
      validation: getConditionalSelectValidation(t, WidgetsKindEnum.Clock),
      componentProps: {
        options: TIMEZONE_OPTIONS,
        isClearable: true,
        isSearchable: true,
        maxMenuHeight: 200,
        usePortal: true,
      },
      isOptionalFn: () => false,
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.Clock),
    },
  ];
}
